import { render, staticRenderFns } from "./WatchlistSelect.vue?vue&type=template&id=a447483c&"
import script from "./WatchlistSelect.vue?vue&type=script&lang=js&"
export * from "./WatchlistSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a447483c')) {
      api.createRecord('a447483c', component.options)
    } else {
      api.reload('a447483c', component.options)
    }
    module.hot.accept("./WatchlistSelect.vue?vue&type=template&id=a447483c&", function () {
      api.rerender('a447483c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/form/WatchlistSelect.vue"
export default component.exports